import { Error } from '@mui/icons-material';
import { Card, CardContent } from '@mui/material';

export default function NotFound() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gray-50">
      <Card sx={{ maxWidth: 400, mx: 2 }}>
        <CardContent sx={{ pt: 3 }}>
          <div className="flex mb-4 gap-2">
            <Error className="h-8 w-8 text-red-500" />
            <h1 className="text-2xl font-bold text-gray-900">404 Page Not Found</h1>
          </div>

          <p className="mt-4 text-sm text-gray-600">
            Did you forget to add the page to the router?
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
